module.exports = __webpack_public_path__ + "static/TiemposText-Regular-c9b785ffc90d51f285dc64ed6df86668.woff2";